import { useEffect, useState } from "react";
import { PrimaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import { ALPHA__Drawer } from "@JohnLewisPartnership/jl-design-system/dist/components/drawer/ALPHA/Drawer";
import ESI from "@JohnLewisPartnership/jl-esi-components";
import { onlineStockFetcher } from "../../../../hooks/useOnlineStock/onlineStockFetcher";
import { Message } from "@JohnLewisPartnership/jl-design-system/dist/components/message/v2/Message";
import styles from "./ShipFromStoreESI.module.scss";
import {
  OUT_OF_STOCK_CODE,
  WARNING_OR_ERROR_EVENT,
} from "../../../../constants/constants";
import { noticeError } from "../../../../utils/newrelic/requests";
interface Props {
  src: string;
  skuId: string;
  stockApiBaseUrl: string;
  stockApiKey: string;
}

export function ShipFromStoreESI({
  src,
  skuId,
  stockApiBaseUrl,
  stockApiKey,
}: Props) {
  useEffect(() => {
    const errorOrWarningHandler = (
      event: CustomEvent<{ errors: { code: string }[] }>,
    ) => {
      const data = event.detail;
      const { errors = [] } = data;
      const hasStockError = errors.some(
        ({ code }) => code === OUT_OF_STOCK_CODE,
      );

      if (hasStockError) {
        setOutOfStock(true);
        setBasketTitle("Out of stock");
      }
    };

    window.addEventListener(WARNING_OR_ERROR_EVENT, errorOrWarningHandler);

    return () => {
      window.removeEventListener(WARNING_OR_ERROR_EVENT, errorOrWarningHandler);
    };
  }, []);

  useEffect(() => {
    setOutOfStock(false);
    setBasketTitle("Add to basket");
  }, [skuId]);

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [outOfStock, setOutOfStock] = useState(false);
  const [basketTitle, setBasketTitle] = useState("Add to basket");

  const handleClick = async () => {
    setLoading(true);
    try {
      const { availabilityStatus } = await onlineStockFetcher(
        skuId,
        stockApiBaseUrl,
        stockApiKey,
      );
      if (availabilityStatus === "SKU_NOT_AVAILABLE") {
        setBasketTitle("Out of stock");
        setOutOfStock(true);
      } else {
        setIsDrawerOpen(true);
      }
    } catch (e: any) {
      noticeError("Could not successfully retrieve online stock data", {
        message: e.message,
        stack: e.stack || "",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {outOfStock && (
        <Message
          body="Sorry, this is out of stock online"
          type={"error"}
          className={styles.outOfStockMessage}
        />
      )}
      <PrimaryButton
        onClick={handleClick}
        submitting={loading}
        disabled={outOfStock}
      >
        {basketTitle}
      </PrimaryButton>

      <ALPHA__Drawer
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        header="Express Checkout"
        isDrawerLeft={false}
        isHeaderFixed={true}
        isNarrow={false}
        fullPage={true}
        rootId={"page-root"}
        isLegacySPDPDrawer={true}
      >
        <ESI src={src} id="express-checkout" />
      </ALPHA__Drawer>
    </>
  );
}
